import { extend } from 'vee-validate';
import * as customValidators from "../_Base/VueCustomValidators";

import { required, regex, min } from 'vee-validate/dist/rules'
extend('required', required)
extend('regex', regex)
extend('min', min)

extend('alpha_extended',  customValidators.alpha_extended);
extend('hslu_email', customValidators.hslu_email);
extend('no_hslu_email', customValidators.no_hslu_email);
extend('dateFormat', customValidators.dateFormat);
extend('dateBetween', customValidators.dateBetween);
extend('telFormat', customValidators.telFormat);
extend('isInteger', customValidators.isInteger);
extend('isDecimal', customValidators.isDecimal);

